import axios from "axios";
import { toast } from "react-toastify";

// Create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // All requests will start from here
  
  headers: {
    "Content-Type": "application/json",
  },
});
console.log("API URL from env:", process.env.REACT_APP_API_URL);

// ✅ Request interceptor → Attach auth token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // token saved at login
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor → Handle global error messages
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong!";
    if (error.response?.status === 401) {
      toast.error("Unauthorized! Please login again.");
    } else {
      toast.error(message);
    }
    return Promise.reject(error);
  }
);

export default api;
